type Point = { x: number; y: number };

// 路径跟踪
export function track(points: Point[]): Point[] {
    if (points.length === 0) return [];

    const path: Point[] = [];
    const pointSet = new Set(points.map(p => `${p.x},${p.y}`));
    const directions = [
        [-1, -1], // 左上
        [0, -1], // 上
        [1, -1], // 右上
        [1, 0], // 右
        [1, 1], // 右下
        [0, 1], // 下
        [-1, 1], // 左下
        [-1, 0], // 左
    ];

    // eslint-disable-next-line prefer-destructuring
    const start = points[0];
    let { x: curX, y: curY } = start;
    let prevDirection = 7;
    let nextDirection = 7;

    // eslint-disable-next-line no-constant-condition
    while (true) {
        path.push({ x: curX, y: curY });
        let foundNextPoint = false;

        for (let i = 0; i < 8; i++) {
            nextDirection = (prevDirection + i) % 8;
            const [dx, dy] = directions[nextDirection];
            const nextX = curX + dx;
            const nextY = curY + dy;

            if (pointSet.has(`${nextX},${nextY}`)) {
                curX = nextX;
                curY = nextY;
                prevDirection = (nextDirection + 6) % 8;
                foundNextPoint = true;
                break;
            }
        }

        if (!foundNextPoint || (curX === start.x && curY === start.y)) break;
    }

    return path;
}

// 移除已经探测到的路径上的点
function removeTrackedPoints(points: Point[], path: Point[]): Point[] {
    const pathSet = new Set(path.map(p => `${p.x},${p.y}`));
    return points.filter(p => !pathSet.has(`${p.x},${p.y}`));
}

// 寻找所有路径
export function trackPaths(points: Point[]): Point[][] {
    const allPaths: Point[][] = [];
    let remainingPoints = [...points];

    while (remainingPoints.length > 0) {
        const path = track(remainingPoints);

        if (path.length >= 3) {
            allPaths.push(path);
        }

        remainingPoints = removeTrackedPoints(remainingPoints, path);
    }

    return allPaths;
}
